//转入记录
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../util.js';
import { ztcgjiaoyijiluxiangqing,superfundCancelFun} from '../../action/investmentAction';
import '../css/Transferrecord.css'
import { hashHistory } from "react-router";
import Password from '../myAssets/payment/Password'
import { Toast } from 'antd-mobile/lib';
class Transferinrecord extends Component {  
  constructor(props) {  
    super(props); 
    this.state = {
      loadingFlag: false,
        xinxi:[],
        isCancel: false,
        pwdFlag: false,
        keyPasswordVal: ""
    } 
  }

  goBack() {
    hashHistory.goBack();
  }
  componentDidMount(){
    let { dispatch } = this.props;
    console.log("1")
    let _this = this;
    let data1 = {
      tradeRequestId:this.props.location.state.tradeRequestId,
  }
      dispatch(ztcgjiaoyijiluxiangqing(data1,this.callbackData.bind(this),_this))
  }
  callbackData(data, sec){
    console.log(data)
      this.setState({
        xinxi:data,
        isCancel: sec
      })
  }
    // 去除时间的时分秒
    timeFormat(date){
      let newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
      return newDate[0]
    }
  backThisFun = () => {
    this.setState({
      pwdFlag: true
    });
  }
  onChangePwd = (val) => {
    this.setState({
      keyPasswordVal:val
    })
  }
  keyOk = () => {
    Toast.loading();
    const data = {
      tradeRequestId:this.props.location.state.tradeRequestId,
      password: Util.encrypt(this.state.keyPasswordVal)
    }
    this.props.dispatch(superfundCancelFun(data, (index, suc) => {
      console.log(suc);
      Toast.hide();
      if(index === 1) {
        this.setState({
          isCancel: false,
          pwdFlag: false
        });
        Toast.info( "撤单成功", Util.ToastTime );
      }
    }, () => {
      Toast.hide();
    }));
  }
  render() {
      let {xinxi}=this.state;
      console.log(xinxi)
      let {commission,confirmTimeStr,businessTimeStr,applicationAmount,}=this.props.location.state
      console.log(confirmTimeStr)
      return (  
        <div style={styles.container}>  
            <div className="NHeader_container">
        <div className="NHeader_wrap" style={{zIndex: 9}}>         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}><img src={require('../../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">交易详情</div>
            <div style={{width:"20%", textAlign: "right"}}>
              {
                this.state.isCancel ?
                <div onClick={this.backThisFun}>
                  <span style={{fontSize: 18 , color: "#ffff" , fontWeight: "500"}}>撤单</span>
                </div>
                :
                null
              }
            </div>
          </div>
        </div>
        </div>
   
          <div className="jiaoyixiangqing" style={{zIndex: 10}}> 
          <div className="jiaouyixiangqingtopshengou">
          <div className="jiaouyixiangqingtop1" >
          转入信息
          </div>
          <div className="jiaouyixiangqingtop2">
            <div className="jiaouyixiangqingtop2top">转入金额</div>
            <div  className="jiaouyixiangqingtop2bottom">{applicationAmount == null ? "--" :Util.thousandCount(applicationAmount) + "元"}</div>
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">转入时间</div>
            <div  className="jiaouyixiangqingtop2bottom">{businessTimeStr ?businessTimeStr:"--"}</div>
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">手续费</div>
            {
                confirmTimeStr == null ?
                <div className="jiaouyixiangqingtop2bottom">--</div>
                :
                <div  className="jiaouyixiangqingtop2bottom">{Util.thousandCount(commission) + "元"}</div>
            }
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">确认完成时间</div>
            {
                confirmTimeStr == null ?
                <div className="jiaouyixiangqingtop2bottom">--</div>
                :
                <div  className="jiaouyixiangqingtop2bottom">{this.timeFormat(confirmTimeStr)}</div>
            }
          </div>
        
         </div>
      
        <div className="jiaouyixiangqingbottom">
         <div className="jiaouyixiangqingtop1">
          基金申购明细
          </div>
           <div style={{flex:1,display:"flex",flexDirection:"column"}}>
           {
           xinxi.map((item,index)=>{
               return(
                <div key={index} >
                {item.businessType==="022" ||item.businessType=== "122"  ? 
          <div className="jiaouyixiangqingbottommingxi">
                  <div className="jiaouyixiangqingbottommingxi1" >
              <div className="jiaouyixiangqingbottommingxi1left" style={{flex:1}}>
               {item.fundName}({item.fundCode})
              </div>
              {
              item.confirmState ==="0" ?
              <div className="jiaouyixiangqingbottommingxi1right">
                <div style={{color:"#F8515C"}}>确认失败</div>
              </div>
              :
              <div className="jiaouyixiangqingbottommingxi1right">
                  {    
                      item.confirmState ==="1"||  item.confirmState ==="2"? 
                      <div style={{color:"#999999"}}>确认成功</div>
                      :
                      <div  style={{color:"#B69271"}}>{item.confirmStateName}</div>
                  }
              </div>
              
              }
          </div>
          <div  className="jiaouyixiangqingbottommingxi2" >
              <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                <div className="jiaouyixiangqingbottommingxi2top" >
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>申购金额</div>
                </div>
                <div style={{color:"#333333"}}>{item.applicationAmount ? Util.thousandCount(item.applicationAmount) + "元" :"--"}</div>
                </div>
                <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>成交份额</div>
                </div>
                <div style={{color:"#333333"}}>{item.confirmState ==="1" ? item.confirmVolume  === null  ? "--" : Util.thousandCount(item.confirmVolume):"--"}</div>
                </div>
              </div>
              
              <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around",alignItems:"end"}}>
              <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div style={{color:"#999999",textAlign:"left"}}>成交净值</div>
                </div>
                    <div  style={{color:"#333333",textAlign:"left"}}>{item.confirmState ==="1" ? item.confirmNav ? Util.thousandCount4(item.confirmNav): "--":"--"}</div>
                </div>
                 
                <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                    <div  style={{color:"#999999",textAlign:"left"}}>手续费</div>
                  </div>
                    <div  style={{color:"#333333",textAlign:"left"}}>{item.confirmState ==="1" ? item.commision ===null ? "--":Util.thousandCount(item.commision)+"元":"--" }</div>
                  </div>
              </div>
          
          </div>
         
          {item.confirmState==="0"||item.confirmState==="1"||item.confirmState==="2"||item.confirmState==="5" ?
             <div className="jiaouyixiangqingbottommingxi4">
                {
                  item.confirmState ==="0" ?
                  <div>
                   <text style={{color:"#999999",fontSize:12}}>确认失败时间  {this.timeFormat(item.confirmDateStr)|| "--"}</text>
                 </div>:
                 <div>
                   {
                       item.confirmState ==="1" || item.confirmState ==="2" ?
                       <text style={{color:"#999999",fontSize:12}}>确认成功时间  {this.timeFormat(item.confirmDateStr)|| "--"}</text>
                       :
                       null
                   }
                 </div>
                }
          </div>
          :null
            }
         
      </div>
      :null
          }
               {item.businessType==="036" ||item.businessType=== "136"  ? 
          <div className="jiaouyixiangqingbottommingxi">
                  <div className="jiaouyixiangqingbottommingxi1" >
              <div className="jiaouyixiangqingbottommingxi1left" style={{flex:1}}>
               {item.fundName}({item.fundCode})
              </div>
              {
              item.confirmState ==="0" ?
              <div className="jiaouyixiangqingbottommingxi1right">
                <div style={{color:"#F8515C"}}>确认失败</div>
              </div>
              :
              <div className="jiaouyixiangqingbottommingxi1right">
                  {    
                      item.confirmState ==="1"||  item.confirmState ==="2"?
                      <div style={{color:"#999999"}}>确认成功</div>
                      :
                      <div  style={{color:"#B69271"}}>{item.confirmStateName}</div>
                  }
              </div>
              
              }
          </div>
          <div  className="jiaouyixiangqingbottommingxi2" >
              <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                <div className="jiaouyixiangqingbottommingxi2top" >
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>申购金额</div>
                </div>
                <div style={{color:"#333333"}}>{item.applicationAmount ? Util.thousandCount(item.applicationAmount) + "元" :"--"}</div>
                </div>
                <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>成交份额</div>
                </div>
                <div style={{color:"#333333"}}>{item.confirmState ==="1" ? item.confirmVolume  === null  ? "--" : Util.thousandCount(item.confirmVolume):"--"}</div>
                </div>
              </div>
              
              <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around",alignItems:"end"}}>
              <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div style={{color:"#999999",textAlign:"left"}}>成交净值</div>
                </div>
                    <div  style={{color:"#333333",textAlign:"left"}}>{item.confirmState ==="1" ? item.confirmNav ? Util.thousandCount4(item.confirmNav): "--":"--"}</div>
                </div>
                 
                <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                    <div  style={{color:"#999999",textAlign:"left"}}>手续费</div>
                  </div>
                    <div  style={{color:"#333333",textAlign:"left"}}>{item.confirmState ==="1" ? item.commision ===null ? "--":Util.thousandCount(item.commision)+"元":"--" }</div>
                  </div>
              </div>
          </div>
          {item.confirmState==="0"||item.confirmState==="1"||item.confirmState==="2"||item.confirmState==="5" ?
             <div className="jiaouyixiangqingbottommingxi4">
                  {
                        item.confirmState ==="0" ?
                        <div>
                         <text style={{color:"#999999",fontSize:12}}>确认失败时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                       </div>:
                       <div>
                         {
                             item.confirmState ==="1" || item.confirmState ==="2" ?
                             <text style={{color:"#999999",fontSize:12}}>确认成功时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                             :
                             null
                         }
                       </div>
                      }
          </div>
          :  <div style={{flex:1,flexDirection:"row"}}>
          </div>
            }
         
      </div>
      :null
          }
           {item.businessType==="036" ||item.businessType=== "136"  ? 
          <div className="jiaouyixiangqingbottommingxizhuanhuan">
                       <div className="jiaouyixiangqingbottommingxi1" >
                                  <div className="jiaouyixiangqingbottommingxitiaocang1r" style={{flex:1}}>
                                         <div style={{flexDirection:"row",alignItems:"center",display:"flex"}} >
                                         <div className="jiaouyixiangqingbottommingxitiaocang1ryuan" style={{backgroundColor:"#D8D8D8"}}></div>
                                         {item.fundName}({item.fundCode})
                                         </div>
                                         <div className="jiaouyixiangqingbottommingxitiaocang1rtu">
                                         <img className="jiaouyixiangqingbottommingxitiaocang1rtu" src={require("../../imgs/zhuanhuan.png")}/>
                                         </div>
                                         <div style={{alignItems:"center",flexDirection:"row",display:"flex"}} >
                                         <div className="jiaouyixiangqingbottommingxitiaocang1ryuan" style={{backgroundColor:"#B69271"}}></div>
                                         {item.targetFundName}({item.targetFundCode})
                                       </div>
                                 </div>
                    {
                    item.confirmState ==="0" ?
                    <div className="jiaouyixiangqingbottommingxi1right">
                      <div style={{color:"#F8515C"}}>确认失败</div>
                    </div>
                    :
                    <div className="jiaouyixiangqingbottommingxi1right">
                        {    
                           item.confirmState ==="1"||item.confirmState ==="2" ?
                            <div style={{color:"#999999"}}>确认成功</div>
                            :
                            <div  style={{color:"#B69271"}}>{item.confirmStateName}</div>
                        }
                    </div>
                    }
                </div>

          <div  className="jiaouyixiangqingbottommingxi2" >
              <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                <div className="jiaouyixiangqingbottommingxi2top" >
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>转换份额</div>
                </div>
                <div style={{color:"#333333"}}>{item.applicationVolume ? Util.thousandCount(item.applicationVolume):""}</div>
                </div>
                <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>转入金额</div>
                </div>
                <div style={{color:"#333333"}}>{item.confirmState ==="1" ?item.confirmAmount ? Util.thousandCount(item.confirmAmount)+"元":"":"--"}</div>
                </div>
              </div>
              <div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"flex-end",alignContent:"space-around"}}>
                            <div className="jiaouyixiangqingbottommingxi2topxiamingzi">
                              <div style={{color:"#999999",textAlign:"left"}}>成交净值</div>
                              <div  style={{color:"#999999",textAlign:"left"}}>手续费</div>
                              </div>
                              <div className="jiaouyixiangqingbottommingxi2topxia">
                              <div  style={{color:"#333333"}}>{item.confirmState ==="1" ? item.confirmNav ? Util.thousandCount4(item.confirmNav): "--":"--"}</div>
                              <div  style={{color:"#333333"}}>{item.confirmState ==="1" ?item.commision ===null ? "--":Util.thousandCount(item.commision)+"元":"--" }</div>
                                </div>
             </div>
          </div>
          {item.confirmState==="0"||item.confirmState==="1"||item.confirmState==="2"||item.confirmState==="5" ?
             <div className="jiaouyixiangqingbottommingxi4">
                   {
                        item.confirmState ==="0" ?
                        <div>
                         <text style={{color:"#999999",fontSize:12}}>确认失败时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                       </div>:
                       <div>
                         {
                             item.confirmState ==="1" || item.confirmState ==="2" ?
                             <text style={{color:"#999999",fontSize:12}}>确认成功时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                             :
                             null
                         }
                       </div>
                      }
          </div>
          :  <div style={{flex:1,flexDirection:"row"}}>
          </div>
            }
         
      </div>
      :null
          }
          {item.businessType==="024" ||item.businessType=== "124"  ? 
          <div className="jiaouyixiangqingbottommingxi">
          <div className="jiaouyixiangqingbottommingxi1" >
              <div className="jiaouyixiangqingbottommingxi1left">
               {item.fundName}({item.fundCode})
              </div>
              {
              item.confirmState ==="0" ?
              <div className="jiaouyixiangqingbottommingxi1right">
                <div style={{color:"#F8515C"}}>确认失败</div>
              </div>
              :
              <div className="jiaouyixiangqingbottommingxi1right">
                  {    
                     item.confirmState ==="1"||item.confirmState ==="2" ?
                      <div style={{color:"#999999"}}>确认成功</div>
                      :
                      <div  style={{color:"#B69271"}}>{item.confirmStateName}</div>
                  }
              </div>
              }
          </div>
          <div  className="jiaouyixiangqingbottommingxi2" >
              <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                <div className="jiaouyixiangqingbottommingxi2top" >
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>赎回份额</div>
                </div>
                <div style={{color:"#333333"}}>{item.applicationVolume ? Util.thousandCount(item.applicationVolume):"--"}</div>
                </div>
                <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div  style={{color:"#999999"}}>到账金额</div>
                </div>
                {
                item.confirmState ==="1"  ?
                <div style={{color:"#333333"}}>{item.confirmAmount  === null  ? "--" : Util.thousandCount(item.confirmAmount)+"元"}</div>
                    :
                <div style={{color:"#333333"}}>--</div>
                }
                </div>
              </div>
              
              <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around",alignItems:"end"}}>
              <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                <div style={{color:"#999999",textAlign:"left"}}>成交净值</div>
                </div>
                    <div  style={{color:"#333333",textAlign:"left"}}>{ item.confirmState ==="1" ? item.confirmNav==null ? "--":Util.thousandCount4(item.confirmNav):"--"}</div>
                </div>
                 
                <div className="jiaouyixiangqingbottommingxi2top">
                <div className="jiaouyixiangqingbottommingxi2top1">
                    <div  style={{color:"#999999",textAlign:"left"}}>手续费</div>
                  </div>
                    <div  style={{color:"#333333",textAlign:"left"}}>{item.confirmState ==="1" ? item.commision ===null ? "--":Util.thousandCount(item.commision)+"元":"--" }</div>
                  </div>
              </div>
          
          </div>
          {item.confirmState==="0"||item.confirmState==="1"||item.confirmState==="2"||item.confirmState==="5" ?
             <div className="jiaouyixiangqingbottommingxi4">
               {
                        item.confirmState ==="0" ?
                        <div>
                         <text style={{color:"#999999",fontSize:12}}>确认失败时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                       </div>:
                       <div>
                         {
                             item.confirmState ==="1" || item.confirmState ==="2" ?
                             <text style={{color:"#999999",fontSize:12}}>确认成功时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                             :
                             null
                         }
                       </div>
                      }
          </div>
          :  <div style={{flex:1,flexDirection:"row"}}>
          </div>
            }
         
      </div>
      :null
          }
          </div>
         
               )
           })
           }
           </div>
         </div>
         </div>
          {
            this.state.pwdFlag?
            <Password _this={this} ztFlag={true} _type="ZT"/>
            :null
          }
        </div>
    
    )
  }  
}  
  
function mapStateToProps(state, ownProps) {
  return {
    shareToInfo:state.shareToInfo,
  }
}
export default connect(mapStateToProps)(Transferinrecord);

const styles ={
  container:{
    flex: 1
  },
  rsyzt: {
    height: 98, 
backgroundColor: "rgba(0, 0, 0, 0.1)",
width: "100%",
flexDirection: "row",
justifyContent: "space-between",
alignItems: "center",
// zIndex:3
},
mainrsyzt: {
  height: 64, 
backgroundColor: "#84C4F6",
width: "100%",
flexDirection: "row",
justifyContent: "space-between",
alignItems: "center",
// zIndex:3
},
};


// WEBPACK FOOTER //
// ./src/components/fundDetail/Transferinrecord.js